import Observer from 'coreClasses/patterns/observable/Observer';
import AbstractAnalyticProvider from './providers/AbstractAnalyticProvider';

/**
 * Represents AnalyticsObserver
 */
class AnalyticsObserver implements Observer {
	private providers: AbstractAnalyticProvider[];

	/**
	 * Represents AnalyticsObserver
	 * @constructor
	 * @param {IAnalyticsProvider[]} providers - analytic providers
	 */
	constructor(providers: AbstractAnalyticProvider[]) {
		this.providers = providers;
	}

	/**
	 * Subscribes to Observable events and forwards them to providers
	 * @param {string} updateId - update ID
	 * @param {object} data - data
	 */
	public update(updateId: any, data: object): void {
		this.providers.map((provider) => provider?.update(updateId, data));
	}
}

export default AnalyticsObserver;
